import * as React from 'react';
import {useEffect, useLayoutEffect, useRef, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useSelector} from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  FormHelperText,
  Box
} from '@mui/material';
import {fullCopy, isValidDate, printVariable, download, uuidv4} from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import {Fragment} from 'react';
import moment from 'moment';
import {Grid} from "@mui/material/";
import useDelegate from "@hooks/useDelegate";
import {styled} from "@mui/material/styles";
import ConfirmDialog from "@components/ConfirmDialog";

import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import CircularProgress from "@mui/material/CircularProgress";
import loading from '@images/loading.gif'
import ImageResize from 'quill-image-resize';

// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ko';
import {TimePicker} from "@mui/x-date-pickers/TimePicker";
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { attempt } from 'lodash';
import useAlert from "@hooks/useAlert";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const ManagerSurveyPartMod = ({record, dialogHandler, callback}) => {
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  // const [activeRow, set_activeRow] = useState({...record})
  // redux
  const codes = useSelector(state => state.codeReducer);
  const questCodes = codes.filter(r => r.codeGroupId === 'SA31')
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const editorRef = useRef(null);
  const [attchList, set_attchList] = useState([])
  const [rendered, set_rendered] = useState(false)
  const quillRef = useRef(null)
  const titleRef = useRef(null)
  const [oldContents, set_oldContents] = useState([])
  const [insImgUrls, set_insImgUrls] = useState([])
  const [files, set_files] = useState([])
  const {alert, renderAlert} = useAlert()
  const contentRef = useRef(null)
  const [quests, set_quests] = useState([])
  const [dirtyFields, set_dirtyFields] = useState({})
  const inputRefs = React.useRef({})
  const handleClose = async (event, reason) => {
    if (reason && reason === "backdropClick") {
      return
    } else {
      await onCancel()
      dialogHandler[1](false)
      if (callback) {
        callback()
      }
    }
  }

  const onChangeFile = (e) => {
		const files = Array.from(e.target.files)
    set_files(files)
    set_attchList([]) 
  }

  const setInputRef = (el, key) => {
    if (el) inputRefs.current[key] = el;
    else delete inputRefs.current[key]; // unmount 시 정리
  }

  const handleFormChange = (e) => {
    console.log('el name:', e.target.name)
    const t = e.target;
    if (!t || !t.name) return;

    // const idx = dirtyFields.findIndex(r => r === t.name)
    // if(t.value.trim().length === 0) {
    //   if(idx < 0) {
    //     dirtyFields.push(t.name)
    //     set_dirtyFields([...dirtyFields])
    //   }
    // }
    // else {
    //   if(idx >= 0) {
    //     dirtyFields.splice(idx, 1)
    //     set_dirtyFields([...dirtyFields])
    //   }
    // }

    if(t.value.trim().length === 0) {
      dirtyFields[t.name] = '값이 비어 있습니다.'
      set_dirtyFields({...dirtyFields})
    }
    else {
      dirtyFields[t.name] = null
      set_dirtyFields({...dirtyFields})
    }
  }

  const fetchAttchList = async () => {
    const url = `/notice/attchs/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    set_attchList(records)
  }

  const onLoad = async () => {
    await fetchAttchList()
  }

  const validate = async (name, value) => {
    let err = ''
    if (name === 'catCode') {
      if (!value) {
        err = '구분이 선택되지 않았습니다.'
      }
    }
    if (name === 'title') {
      if (!value) {
        err = '제목이 비어 있습니다.'
      }
    }
    if (name === 'content') {
      const imageTagRegex = /<img.*?>/i

      // 이미지만 있어도 OK
      if(imageTagRegex.test(value)) {
      }
      else {
        if(value.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
          err = '내용이 비어 있습니다.'
          
        }
      }
    }
    if(name === 'day') {
      if(activeRow.catCode === 'S002') {
        if(!moment(value, dateFormat, true).isValid()) {
          err = '날짜 형식에 맞지 않습니다.'
        }
      }
    }
    if(name === 'time1') {
      if(activeRow.catCode === 'S002') {
        if(!moment(value, dateFormat, true).isValid()) {
          err = '시작시간이 형식에 맞지 않습니다.'
        }
      }
    }
    if(name === 'time2') {
      if(activeRow.catCode === 'S002') {
        if(!moment(value, dateFormat, true).isValid()) {
          err = '종료시간이 형식에 맞지 않습니다.'
        }
      }
    }
    if(name === 'error') {
      if(activeRow.catCode === 'S002') {
        const time1 = moment(activeRow.time1, dateFormat)
        const time2 = moment(activeRow.time2, dateFormat)
        if(!time1.isBefore(time2)) {
          err = '시작시간은 종료시간보다 전이어야 합니다.'
        }
      }
    }

    return err
  }

  const onSubmit = async () => {

    const row = {...activeRow}
    if(activeRow.catCode === 'S002') {
      const sTime = moment(activeRow.day, dateFormat).format('YYYY-MM-DD') + ' ' + moment(activeRow.time1, dateFormat).format('HH:mm:00')
      const eTime = moment(activeRow.day, dateFormat).format('YYYY-MM-DD') + ' ' + moment(activeRow.time2, dateFormat).format('HH:mm:00')
      row.sTime = sTime
      row.eTime = eTime
    }
    else {
      row.sTime = ''
      row.eTime = ''
    }

    const url = `/notice/school/${schola.id}`
    const oldImgUrls = getImgUrls(oldContents)
    const newImgUrls = getImgUrls(quillRef.current.getEditor().getContents())
    const data = {
      oldImgUrls: oldImgUrls,
      newImgUrls: newImgUrls,
      insImgUrls: insImgUrls,
      row: JSON.stringify(row),
      oldAttchIdList: attchList.map(a => a.id)
    }


    const formData = new FormData()
    files.forEach((file, index) => {
      if (file instanceof File) {
        // formData.append(`files`, file)
        const f = new File([file], file.name, { type: file.type }) 
        formData.append(`files`, f)

      }
    })

    console.log('files => ', files)

    const jsonData = JSON.stringify(data)
    
    formData.append(
      "body",
      new Blob([jsonData], { type: "application/json" })
    )

    const resp = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

    if (resp.data.repCode === 'ack') {
       alert('저장되었습니다.')
      const repMessage = JSON.parse(resp.data.repMessage)
      const record = JSON.parse(repMessage.record)

      await handleChange({target: {name: 'id', value: record.id}})
      updateState()

      //
      set_oldContents(quillRef.current.getEditor().getContents())
      set_insImgUrls([])
      if (callback) {
        callback()
      }
    } else {
      alert(resp.repMessage)
    }
  }


  const onCancel = async() => {
    if(insImgUrls.length > 0) {
      // delete files in sever
      const url = `/bucket/del/img/${schola.id}`
      const data = {
        insImgUrls: insImgUrls
      }

      const resp = await WebService.post(url, data)
      if (resp.repCode === 'ack') {

      } else {
        console.log(resp.repMessage)
      }
    }
  }

  const vvv = async () => {
    
    console.log('dirtyFields=>', dirtyFields)
    console.log('activeRow=>', activeRow)
    // 화면에 보여질 에러 들 먼저 셋팅
    let firstQuestErrorKey = null
    let firstAnsErrorKey = null

    Object.keys(dirtyFields).forEach((key) => {
      delete dirtyFields[key];
    });

    const emsg = '값이 비어 있습니다.'
    if(!activeRow.title) {
      dirtyFields.title = emsg
    }
    if(!activeRow.startTime1) {
      dirtyFields.startTime1 = emsg
    }

    if(!activeRow.endTime1) {
      dirtyFields.endTime1 = emsg
    }

    for(const quest of quests) {
      if(!quest.quest) {
        dirtyFields[quest.key] = emsg
        if(!firstQuestErrorKey) {
          firstQuestErrorKey = quest.key
        }
      }
      for(const ans of quest.anss) {
        if(!ans.ans) {
          dirtyFields[ans.key] = emsg
          if(!firstAnsErrorKey) {
            firstAnsErrorKey = ans.key
          }
        }
        
      }
    }
    
    set_dirtyFields({...dirtyFields})

    // 개별적 알럿
    if(!activeRow.title) {
      alert('제목이 비어 있습니다.')
      inputRefs.current.title?.focus()
      return
    }
    if(!activeRow.startTime1) {
      alert('설문조사 시작일이 비어 있습니다.')
      inputRefs.current.startTime1?.focus()
      return
    }

    if(!activeRow.endTime1) {
      alert('설문조사 종료일이 비어 있습니다.')
      inputRefs.current.endTime1?.focus()
      return
    }

    if(quests.length == 0) {
      alert('한 개 이상의 질문이 필요합니다.')
      return
    }

    if(firstQuestErrorKey) {
      alert('질문이 비어 있습니다.')
      inputRefs.current[firstQuestErrorKey]?.focus()
      return
    }
    
    if(firstAnsErrorKey) {
      alert('선택지가 비어 있습니다.')
      inputRefs.current[firstAnsErrorKey]?.focus()
      return
    }

    const shortQuests = quests.filter(r => (r.questCode === 'Q000' || r.questCode === 'Q001') && r.anss.length < 2)
    if(shortQuests.length > 0) {
      const quest = shortQuests[0]
      alert('단일응답 또는 복수응답일 경우 2개 이상의 선택지가 필요합니다.')
      inputRefs.current[quest.key]?.focus()
      return
    }

    if(Object.keys(dirtyFields).length > 0) {
      alert('화면의 에러를 확인해 주세요.')
      return
    }

    return true
    
  }

  const {activeRow, errors, updateState, handleChange, handleSubmit, factor} = useDelegate({
    initialValues: {...record},
    onSubmit: onSubmit,
    validate: validate,
  });

  const getImgUrls = (delta) => {
    return delta.ops.filter(i => i.insert && i.insert.image).map(i => i.insert.image)
  }

  const handleDelta = (delta) => {
    const inserted = getImgUrls(delta).filter(r => !r.startsWith("data:"))
    const newInsImgUrls = [...insImgUrls, ...inserted]
    set_insImgUrls(newInsImgUrls)
  }

  const catCodeList = codes.filter(r => r.codeGroupId === 'SA24')

  const FormHelperTexts = styled(FormHelperText)`
    width: 100%;
    padding-left: 16px;
    font-weight: 700 !important;
    color: #d32f2f !important;
  `;

  useEffect(() => {
    onLoad()
  },[])

  const onNewQuest = () => {
    const quest = {
      surveyId: -1,
      sqNum: 0,
      quest: '',
      questCode: 'Q000',
      mustYn: 'Y',
      anss:[],
      key: uuidv4()
    }
    quests.push(quest)
    for(let i=0;i<4;i++) {
      onNewAns(quests.length - 1)
    }
    
    set_quests([...quests])
  }

  const onNewAns = (questIdx) => {
    const ans = {
      id: -1,
      questId: quests[questIdx].id,
      ans: '',
      key: uuidv4(),
    }
    quests[questIdx].anss.push(ans)
    set_quests([...quests])
  }

  useEffect(() => {
    if(quests.length == 0) {
      onNewQuest()
    }
  }, []);

  return (
    <Box component="form" onBlur={handleFormChange}>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='md' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            설문조사
          </Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent style={{minHeight:600}}>
          <br/>
          <Grid container spacing={1}>

            <Grid item xs={12}>
              <TextField
                label={'제목'}
                fullWidth
                required
                inputRef={(el) => setInputRef(el, 'title')}
                name={'title'}
                defaultValue={activeRow['title']}
                onChange={e => {
                  activeRow.title = e.target.value
                }}
              />
              <FormHelperTexts>{dirtyFields.title}</FormHelperTexts>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={'설명'}
                fullWidth
                multiline
                rows={4}
                name={'content'}
                defaultValue={activeRow['content']}
                onChange={e => {
                  activeRow.content = e.target.value
                }}
              />
              <FormHelperTexts>{errors["note"]}</FormHelperTexts>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        label={'설문조사 시작일'}
                        required
                        value={activeRow.startTime1}
                        defaultValue={null}
                        name={'startTime1'}
                        inputFormat="YYYY-MM-DD"
                        onChange={(newValue) => {
                          if (!newValue || !moment(newValue).isValid()) {
                            activeRow.startTime1 = null;
                            handleChange({ target: { name: 'startTime1', value: null } });
                            updateState();
                            set_dirtyFields({...dirtyFields, startTime1:'값이 비어 있습니다.'})
                            return;
                          }

                          const dtime = moment(new Date(newValue))
                          const d = dtime.format(dateFormat)
                          activeRow['startTime1'] = d
                          // set_activeRow({...activeRow})
                          console.log('d===>', d)
                          handleChange({ target: { name: 'startTime1', value: d } })
                          set_dirtyFields({...dirtyFields, startTime1:''})
                          updateState()
                        }}
                        renderInput={(params) => 
                          <TextField name={'startTime1'} fullWidth size="small" {...params}
                            inputRef={el => {
                              params.inputRef(el)
                              setInputRef(el, 'startTime1')
                            }} 
                          />
                        }
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{dirtyFields.startTime1}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      disabled={true}
                      size="small"
                      required
                      label={'설문조사 시작시간'}
                      value={activeRow['startTime2']}
                      onChange={handleChange}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    <FormHelperTexts>{errors['startTime2']}</FormHelperTexts>
                  </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        label={'설문조사 종료일'}
                        required
                        name={'endTime1'}
                        value={activeRow.endTime1}
                        inputFormat="YYYY-MM-DD"
                        
                        onChange={(newValue) => {
                          if (!newValue || !moment(newValue).isValid()) {
                            activeRow.endTime1 = null;
                            handleChange({ target: { name: 'endTime1', value: null } });
                            updateState();
                            set_dirtyFields({...dirtyFields, endTime1:'값이 비어 있습니다.'})
                            return;
                          }

                          const dtime = moment(new Date(newValue))
                          const d = dtime.format(dateFormat)
                          activeRow['endTime1'] = d
                          handleChange({ target: { name: 'endTime1', value: d } })
                          updateState()
                          set_dirtyFields({...dirtyFields, endTime1:''})
                        }}
                        renderInput={(params) => 
                          <TextField name={'endTime1'} fullWidth size="small" {...params}
                            inputRef={el => {
                              params.inputRef(el)
                              setInputRef(el, 'endTime1')
                            }} 
                            
                          />
                        }
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{dirtyFields.endTime1}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      size="small"
                      disabled={true}
                      required
                      label={'설문조사 종료시간'}
                      value={activeRow['endTime2']}
                      onChange={handleChange}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    <FormHelperTexts>{errors['endTime2']}</FormHelperTexts>
                  </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {
                quests.length == 0 ? (
                  <FormHelperTexts>{'한 개 이상의 질문이 필요합니다. 질문추가를 해 주세요.'}</FormHelperTexts>
                ) : null
              }
            </Grid>
            <Grid item xs={12}>
              {
                quests.map((quest, idx) => (
                  <Grid container spacing={1} key={quest.key}>
                    <Grid item xs={12}>
                      <Grid container spacing={1}>
                        <Grid item xs={11}>
                          <TextField
                            // style={{ backgroundColor: idx % 2 === 0 ? '#e8eaf6': '#fff'}}
                            style={{ backgroundColor: '#e8eaf6'}}
                            label={`${idx + 1}. 질문`}
                            required
                            fullWidth
                            inputRef={(el) => setInputRef(el, quest.key)}
                            name={quest.key}
                            defaultValue={quest.quest}
                            // value={quest.quest}
                            onChange={(e) => {
                              quest.quest = e.target.value
                              // set_quests([...quests])
                            }}
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <IconButton onClick={() => {
                            quests.splice(idx, 1)
                            set_quests([...quests])
                          }}>
                            <CloseIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <FormHelperTexts>{dirtyFields[quest.key]}</FormHelperTexts>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl>
                        <FormLabel id={'m_' + idx}>응답필수 여부</FormLabel>
                        <RadioGroup
                          aria-labelledby={'m_' + idx}
                          name="radio-buttons-group"
                          row
                        >
                          {
                            [{code:'Y', name:'Y'}, {code: 'N', name: 'N'}].map((code, idx2) => (
                              <FormControlLabel checked={quest.mustYn === code.code} value={code.code} control={<Radio />} label={code.name} 
                                onChange={() => {
                                  quest.mustYn = code.code
                                  set_quests([...quests])
                                }}
                              />
                            ))
                          }
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl>
                        <FormLabel id={'qc_' + idx}>응답유형</FormLabel>
                        <RadioGroup
                          aria-labelledby={'qc_' + idx}
                          name="radio-buttons-group"
                          row
                        >
                          {
                            questCodes.map((code, idx2) => (
                              <FormControlLabel checked={quest.questCode === code.code} value={code.code} control={<Radio />} label={code.name} 
                                onChange={() => {
                                  quest.questCode = code.code
                                  if(code.code === 'Q002') {
                                    quest.anss = []
                                  }
                                  set_quests([...quests])
                                }}
                              />
                            ))
                          }
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    {
                      quest.questCode === 'Q000' || quest.questCode === 'Q001' ? (
                        <>
                          {
                            quest.anss.map((ans, idx2) => (
                              <>
                                <Grid item xs={12}>
                                  <Grid container key={ans.key} spacing={1}>
                                    <Grid item xs={11}>
                                      <TextField
                                        label={`${idx2 + 1}. 선택지`}
                                        required
                                        fullWidth
                                        inputRef={(el) => setInputRef(el, ans.key)}
                                        name={ans.key}
                                        defaultValue={ans.ans}
                                        onChange={(e) => {
                                          ans.ans = e.target.value
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={1}>
                                      <IconButton onClick={() => {
                                        quest.anss.splice(idx2, 1)
                                        set_quests([...quests])
                                      }}>
                                        <CloseIcon />
                                      </IconButton>
                                    </Grid>
                                  </Grid>
                                  <FormHelperTexts>{dirtyFields[ans.key]}</FormHelperTexts>
                                </Grid>
                                {/* <Grid item xs={12}>
                                   <FormHelperTexts>{dirtyFields[ans.key]}</FormHelperTexts>
                                </Grid> */}
                              </>
                              
                            ))
                          }
                          <Grid item xs={12}>
                            {
                              quest.questCode !== 'Q002' && quest.anss.length < 2 ? (
                                <FormHelperTexts>{'두 개 이상의 선택지가 필요합니다.'}</FormHelperTexts>
                              ) : null
                            }
                          </Grid>
                          <Grid item xs={12}>
                            <Button
                              onClick={() => {
                                onNewAns(idx)
                              }}
                            >
                              응답 선택지 추가
                            </Button>
                            
                          </Grid>
                          
                          
                        </>
                        
                      ) : null
                    }
                    <Grid item xs={12} style={{marginBottom:5}}>
                      <Divider fullWidth/>
                    </Grid>
                    
                  </Grid>
                  
                ))
              }  
            </Grid>
            
          </Grid>
          
        </DialogContent>
        <DialogActions >
          <Grid container spacing={1}>
            <Grid item xs={12} style={{display:'flex', justifyContent:'flex-start', paddingLeft:25}}>
              <Button onClick={onNewQuest} variant='contained' >
                질문추가
              </Button>
            </Grid>
            <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
              <Button onClick={handleClose} style={{marginRight:10}}>
                취소
              </Button>
              
              <ConfirmDialog
                btn={
                <Button variant='contained' disabled={false}
                  onMouseOver={() => {
                    document.activeElement?.blur();
                  }}
                > 
                  저장
                </Button>
                }
                title={'저장'}
                content={'내용을 저장하시겠습니까?'}
                bc={'primary'}
                preHandle={ async () => {
                  return vvv()
                }}
                perform={() => {
                  alert('OK')
                }}
              />
            </Grid>
          </Grid>
          
        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </Box>
  )
}

export default ManagerSurveyPartMod
